import { FormattedMessage } from 'react-intl';
import { MouseEventHandler, ReactElement, ReactNode } from 'react';
import { Props } from 'react-intl/src/components/message';

export const PoolFormattedMessage = <V extends Record<string, unknown>>(props: Props<V>): ReactElement => (
    <FormattedMessage
        {...props}
        values={{
            ...props.values,
            strong: (chunks: ReactNode) => <strong>{chunks}</strong>,
            noWrap: (chunks: ReactNode) => <span style={{ whiteSpace: 'pre' }}>{chunks}</span>,
            a: (chunks: ReactNode) => (
                <a
                    href={(props.values?.['href'] as string) ?? '#'}
                    target={(props.values?.['target'] as string) ?? undefined}
                >
                    {chunks}
                </a>
            ),
            click: (chunks: ReactNode) => {
                return <span onClick={props.values?.['onClick'] as MouseEventHandler<HTMLSpanElement>}>{chunks}</span>;
            },
            br: <br />,
        }}
    />
);
